var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NeoInput',_vm._g(_vm._b({attrs:{"bg":'#fff',"borderFull":'1px solid #dedede',"value":_vm.valueSync,"role":"textbox","placeholder":_vm.getPlaceholder},on:{"input":_vm.onInput}},'NeoInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }